import { motion } from 'framer-motion';
import { X, ShieldCheck, RefreshCw, ArrowRight, CreditCard } from 'lucide-react';
import { useModal } from '../../../hooks/modalContext';
import styles from './CardAuthDisclosure.module.css';

const CardAuthDisclosure = () => {
  const { setModal, modalState } = useModal();
  const paymentType = modalState?.paymentType || 'card';

  const handleContinue = () => {
    setModal('add-card', { ...modalState, paymentType });
  };

  const handleBack = () => {
    setModal('add-payment-method', modalState ?? undefined);
  };

  return (
    <motion.div
      className={styles.container}
      initial={{ opacity: 0, y: 8 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -8 }}
      transition={{ duration: 0.25 }}
    >
      <button type='button' className={styles.closeBtn} onClick={handleBack} aria-label='Close'>
        <X size={24} stroke='#0E0E0B' />
      </button>

      <div className={styles.content}>
        {/* Icon and badge */}
        <div className={styles.iconWrapper}>
          <div className={styles.iconCircle}>
            <ShieldCheck className={styles.icon} strokeWidth={2} />
          </div>
          <span className={styles.badge}>Verification step</span>
        </div>

        <h2 className={styles.title}>Before we add your {paymentType}</h2>
        <p className={styles.subtitle}>
          To verify your card, we’ll run a small authorization. Here’s what to expect:
        </p>

        {/* Main disclosure card */}
        <div className={styles.disclosureCard}>
          <div className={styles.amountRow}>
            <CreditCard className={styles.cardIcon} />
            <div className={styles.amountContent}>
              <span className={styles.amountLabel}>Temporary hold</span>
              <span className={styles.amountValue}>$0 – $2 CAD</span>
            </div>
          </div>
          <p className={styles.disclosureText}>
            To verify your payment method, a temporary <strong>micro-deposit of $0–$2 CAD</strong>{' '}
            may appear on your account. This amount is temporary, and the{' '}
            <strong>full micro-deposit will be automatically refunded</strong> within a few business
            days.
          </p>
          <div className={styles.refundRow}>
            <RefreshCw className={styles.refundIcon} />
            <span>No action needed; the hold is released by your bank.</span>
          </div>
        </div>

        <p className={styles.footerNote}>
          This is a standard card verification used by many services.
        </p>

        <div className={styles.actions}>
          <button type='button' className={styles.backBtn} onClick={handleBack}>
            Back
          </button>
          <button type='button' className={styles.continueBtn} onClick={handleContinue}>
            <span>Continue to add card</span>
            <ArrowRight size={20} strokeWidth={2} />
          </button>
        </div>
      </div>
    </motion.div>
  );
};

export default CardAuthDisclosure;
